/**
 * @generated SignedSource<<8ae9d91bf66291d9ff54e6955b957d98>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerAddGalleryDialogPrintTypesQuery$variables = Record<PropertyKey, never>;
export type composerAddGalleryDialogPrintTypesQuery$data = {
  readonly printTypes: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly printTypeID: number;
      };
    }> | null;
  } | null;
};
export type composerAddGalleryDialogPrintTypesQuery = {
  response: composerAddGalleryDialogPrintTypesQuery$data;
  variables: composerAddGalleryDialogPrintTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 200
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "printTypeID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerAddGalleryDialogPrintTypesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PrintTypesConnection",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PrintType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "printTypes(first:200)"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "composerAddGalleryDialogPrintTypesQuery",
    "selections": [
      {
        "alias": null,
        "args": (v0/*:: as any*/),
        "concreteType": "PrintTypesConnection",
        "kind": "LinkedField",
        "name": "printTypes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PrintTypesEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PrintType",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "printTypes(first:200)"
      }
    ]
  },
  "params": {
    "cacheID": "d0e80c5466c28e515f07889e2ee8057e",
    "id": null,
    "metadata": {},
    "name": "composerAddGalleryDialogPrintTypesQuery",
    "operationKind": "query",
    "text": "query composerAddGalleryDialogPrintTypesQuery {\n  printTypes(first: 200) {\n    edges {\n      node {\n        printTypeID\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b2b285773b547fe0480a8b8aea6eddad";

export default node;
